import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, Mail, Lock, User } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function GoogleButton() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button onClick={handleGoogle} data-testid="google-signup-btn"
      className="w-full flex items-center justify-center gap-3 bg-white font-bold px-5 py-3.5 rounded-xl border-2 border-ink neo-press">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
      Continue with Google
    </button>
  );
}

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="grid place-items-center w-12 h-12 bg-brand-mint neo rounded-xl mx-auto mb-4"><Sparkles className="w-6 h-6" /></span>
          <h1 className="font-display font-bold text-4xl">Join FabricATE</h1>
          <p className="font-semibold text-ink/70 mt-1">Create art you can wear.</p>
        </div>
        <div className="bg-white neo-lg rounded-3xl p-7">
          <GoogleButton />
          <div className="flex items-center gap-3 my-6"><div className="flex-1 border-t-2 border-ink" /><span className="text-xs font-bold uppercase text-ink/50">or</span><div className="flex-1 border-t-2 border-ink" /></div>
          <form onSubmit={submit} className="space-y-4">
            {error && <div className="bg-brand-pink border-2 border-ink rounded-lg p-3 text-sm font-bold" data-testid="register-error">{error}</div>}
            <div className="flex items-center gap-2 border-2 border-ink rounded-xl px-3">
              <User className="w-4 h-4 shrink-0" />
              <input required value={form.name} onChange={upd("name")} placeholder="Full name" data-testid="register-name" className="w-full py-3 outline-none font-semibold bg-transparent" />
            </div>
            <div className="flex items-center gap-2 border-2 border-ink rounded-xl px-3">
              <Mail className="w-4 h-4 shrink-0" />
              <input type="email" required value={form.email} onChange={upd("email")} placeholder="Email" data-testid="register-email" className="w-full py-3 outline-none font-semibold bg-transparent" />
            </div>
            <div className="flex items-center gap-2 border-2 border-ink rounded-xl px-3">
              <Lock className="w-4 h-4 shrink-0" />
              <input type="password" required minLength={6} value={form.password} onChange={upd("password")} placeholder="Password (min 6 chars)" data-testid="register-password" className="w-full py-3 outline-none font-semibold bg-transparent" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-ink text-paper font-bold px-6 py-3.5 rounded-xl neo-press border-2 border-ink disabled:opacity-60" data-testid="register-submit">
              {loading ? "Creating…" : "Create Account"}
            </button>
          </form>
          <p className="text-center font-semibold text-ink/70 mt-5">
            Already have an account? <Link to="/login" className="font-bold underline" data-testid="to-login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
